import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { IEBaseContainerElement, IECategoryContainerElement, GroupContainer } from './style';
import { IEFormDataService } from '../utils/ieFormDataService';
import { TriggerFiguresService } from "../utils/triggerFiguresService";
import { SummaryCalculator } from '../utils/summaryCalculator';
import { InputValidatorService } from '../utils/validatorService';
import { IEFieldContainer } from "../IEFieldContainer";
import { IESummaryContainer } from "../IESummaryContainer";
import { IE_FREQUENCY_TYPE } from '../../../../utils/constants';
import { FLEXIBLE_EXPENSES } from '../../SFS/utils/constants';
import { Spinner } from "../../../_misc/Spinner";
import { isMobile } from 'react-device-detect';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import { CustomTabs } from '../_misc/CustomTabs/index';

import "react-datepicker/dist/react-datepicker.css";
import 'moment-timezone';


export const IEFormSFSBaseContainer = (props) => {
    const { t } = useTranslation();
    const [tabItems] = useState(IEFormDataService.generateTabs(props.formRecord.formData).map(x => { return { ...x, text: t(`LABELS.${x[isMobile? 'dataObjectMobile' : 'dataObject'].toUpperCase()}`) } }));
    const [selectedTab, setSelectedTab] = useState(0);
    const [formData, setFormData] = useState(props.formRecord.formData);
    const [primitiveCategories, setPrimitiveCategories] = useState(<></>);
    const [groupedCategories, setGroupedCategories] = useState(<></>);
    const currentExceededAmmountToastRef = useRef({ id: null });
    const triggeredExceededAmountToasts = useRef([]);

    useEffect(() => {
        if (selectedTab < tabItems.length){
            SummaryCalculator.recalculate(formData, props.roundingModel);
            setCategories(selectedTab);
        }
        props.handleStateChanges({ currentTab: selectedTab, tabsLength: tabItems.length, dataToSave: selectedTab === tabItems.length ? { ...props.formRecord, formData: formData } : null });

        document.body.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [selectedTab]);

    useEffect(() => {
        if (selectedTab < tabItems.length) {
            SummaryCalculator.recalculate(formData, props.roundingModel);
            setCategories(selectedTab);
        }
    }, [props.formRecord.formData.householdDetails]);

    useEffect(() => {
        if (props.onBackwardButtonClicked)
            setSelectedTab((selectedTab) => selectedTab - 1);
    }, [props.onBackwardButtonClicked]);

    useEffect(() => {
        if (props.onForwardButtonClicked) {
            if (!isformDataValid(true)) {
                showWarnMessage();
                return;
            }
            setSelectedTab((selectedTab) => selectedTab + 1);
        }
    }, [props.onForwardButtonClicked]);

    useEffect(() => {
        if (props.onMockDataTrigger) {
            for (let category in formData) {
                if (typeof formData[category] === 'object') {
                    for (let subcategory in formData[category]) {
                        if (formData[category][subcategory]) {
                            for (let dataIndex in formData[category][subcategory].data) {
                                formData[category][subcategory].data[dataIndex].note = null;
                                formData[category][subcategory].data[dataIndex].amount = null;
                                formData[category][subcategory].data[dataIndex].frequency = IE_FREQUENCY_TYPE[2].Id;

                                if ((Math.floor(Math.random() * 10) + 1) === 7) {
                                    formData[category][subcategory].data[dataIndex].note = (Math.random() + 1).toString(36).substring(2);
                                }
                                else {
                                    formData[category][subcategory].data[dataIndex].amount = Math.floor(Math.random() * 100) + 1;
                                }
                            }
                        }
                    }
                }
            }

            SummaryCalculator.recalculate(formData, props.roundingModel);
            setFormData({...formData});
            setCategories(selectedTab)
        }
    }, [props.onMockDataTrigger]);

    useEffect(() => {
        props.handleSummaryChanged({...formData.summary});
    }, [formData]);

    const onTabsSelectionChanged = (index) => {
        if (index > selectedTab && !isformDataValid(true)) {
            showWarnMessage();
            return;
        }

        setSelectedTab(index);
    }

    const handlePrimitiveValueChange = (e) => {
        if (typeof getTabCategories(selectedTab)[e.title] !== 'object' || e.title === 'note') {
            if (getTabCategories(selectedTab)[e.title] !== e.value) {
                switch (e.title) {
                    case 'spouseRefusedToDeclareIncome':
                        formData['income'][e.title] = e.value;
                        for (let index in formData['income']['jointBankruptDebtorIncome'].data)
                            formData['income']['jointBankruptDebtorIncome'].data[index].isDisabled = e.value;
                        break;
                    case 'noAdults':
                    case 'noChildUnder18':
                    case 'note':
                        getTabCategories(selectedTab)[e.title] = e.value !== undefined ? e.value : null;
                        break;
                    default:
                        break;
                }

                SummaryCalculator.recalculate(formData, props.roundingModel);

                setFormData(formData);
                setCategories(selectedTab);
            }
        }
    }

    const handleListChangedValue = (e) => {
        const indexToUpdate = getTabCategories(selectedTab)[e.parent].data.findIndex(x => x.type === e.title);
        const prevObjectState = { ...getTabCategories(selectedTab)[e.parent].data[indexToUpdate] };

        getTabCategories(selectedTab)[e.parent].data[indexToUpdate].amount = e.value;
        getTabCategories(selectedTab)[e.parent].data[indexToUpdate].frequency = e.frequency;
        getTabCategories(selectedTab)[e.parent].data[indexToUpdate].note = e.note;
        getTabCategories(selectedTab)[e.parent].data[indexToUpdate].isTouched = e.isTouched;

        SummaryCalculator.recalculate(formData, props.roundingModel);

        if (prevObjectState.amount !== e.value || prevObjectState.frequency !== e.frequency || prevObjectState.isTouched !== e.isTouched)
            setCategories(selectedTab)

        setFormData({ ...formData });

        if (e.isTouched && (prevObjectState.amount !== e.value || prevObjectState.frequency !== e.frequency) && TriggerFiguresService.hasTriggerFiguresConfigured(e.parent, props.triggerFigures)) {
            var triggerValue = TriggerFiguresService.calculateTriggerFigures(e.parent, props.triggerFigures, props.formRecord.formData.householdDetails);

            if (triggerValue < getTabCategories(selectedTab)[e.parent].total)
                triggerExceededAmmountToast(e.parent, triggerValue);
            else
                triggeredExceededAmountToasts.current = triggeredExceededAmountToasts.current.filter(x => x !== e.parent)
        }
    }

    const isformDataValid = (setTouched) => {
        let isValid = true;
        const currentTabCategory = tabItems[selectedTab].dataObject;

        for (const prop in getTabCategories(selectedTab)) {
            if (typeof getTabCategories(selectedTab)[prop] === "object") {
                var items = getTabCategories(selectedTab)[prop];

                if (items !== null && items.data) {
                    if ((currentTabCategory === "fixed_expenditure" && FLEXIBLE_EXPENSES.includes(prop)) ||
                        (currentTabCategory === "flexible_expenditure" && !FLEXIBLE_EXPENSES.includes(prop))) {
                        continue;
                    }

                    if (props.formRecord.isLocked === false && items.data.some(x => !InputValidatorService.isValidField(x)))
                        isValid = false;

                    if (setTouched) {
                        for (const item in items.data)
                            items.data[item].isTouched = true;
                    }
                }
            }
        }

        if (!props.formRecord.createdDate)
            isValid = false;

        setFormData({ ...formData });

        if (setTouched && !isValid)
            setCategories(selectedTab)

        return isValid;
    }

    const showWarnMessage = () =>
        toast.warn(t('NOTIFICATIONS.FILL_REQUIRED_FIELDS'), { progress: undefined });

    const showErrorMessage = (message, id) => {
        var toastId = `${id}Toast`;

        if (currentExceededAmmountToastRef.current.id === toastId)
            return;

        currentExceededAmmountToastRef.current = { ...currentExceededAmmountToastRef.current, id: toastId };

        toast.dismiss();
        toast.error(message, {
            progress: undefined,
            toastId: toastId,
            onClose: () => {
                if (currentExceededAmmountToastRef.current.id === toastId)
                    currentExceededAmmountToastRef.current = { ...currentExceededAmmountToastRef.current, id: null };
            }
        });
    }

    const setCategories = (selectedTab) => {
        var data = getTabCategories(selectedTab);

        var categories = IEFormDataService.generateCategories(data, tabItems[selectedTab].dataObject);
        setPrimitiveCategories(getPrimitiveCategories(categories));
        setGroupedCategories(getGroupedCategories(categories))
    }

    const getTabCategories = (selectedTab) => {
        var tabName = tabItems[selectedTab].dataObject;

        if (tabName === 'income')
            return formData[tabName];

        if (tabName.indexOf('expenditure') > -1)
            return formData['expenditure'];
    }

    const getPrimitiveCategories = (data) => {
        return data.filter(x => !x.data && (props.isJoint === false || (x.key !== 'spouseRefusedToDeclareIncome'))).map((item) => <IEFieldContainer
            key={item.key}
            title={item.key}
            value={item.content}
            note={item.note}
            elementType={getPrimitiveFieldType(item.key)}
            isLocked={props.formRecord.isLocked}
            isInteger={true}
            isJoint={props.isJoint}
            handleValueChange={handlePrimitiveValueChange} />)
    };

    const getPrimitiveFieldType = (field) => {
        if (field === 'familyUnitMemberRefusesToDeclareIncome' || field === 'spouseRefusedToDeclareIncome')
            return 'boolean';

        if (field === 'noAdults' || field === 'noChildUnder18')
            return 'number';

        if (field === 'note')
            return 'string';

        return null;
    }

    const labelsToTransform = ['bankruptDebtorIncome', 'nonDiscretionaryBankruptDebtor'];

    const getGroupTotalLabel = (key) => {
        if (!TriggerFiguresService.hasTriggerFiguresConfigured(key, props.triggerFigures)) {
            return <>
                <h6 className="group-total">
                    {formatValue(getTabCategories(selectedTab)[key].total)}
                </h6>
            </>;
        }

        var triggerValue = TriggerFiguresService.calculateTriggerFigures(key, props.triggerFigures, props.formRecord.formData.householdDetails);

        if (triggerValue < getTabCategories(selectedTab)[key].total) {
            return <div onClick={(e) => showExceedsErrorMessage(e, key, triggerValue)}>
                <div id={key + 'label'} className="group-total exceeded-guidelines" role="button" aria-label={t(`LABELS.${key.toUpperCase()}`) + ' ' + t('LABELS.GUDELINES_EXCEEDED')}>
                    <div className="alert-icon"></div>
                    <span>{formatValue(getTabCategories(selectedTab)[key].total)}</span>
                </div>
            </div>;
        }

        return <>
            <h6 className="group-total">
                {formatValue(getTabCategories(selectedTab)[key].total)}
            </h6>
        </>;
    }

    const triggerExceededAmmountToast = (key, triggerValue) => {
        if (triggeredExceededAmountToasts.current.includes(key))
            return;

        showExceedsErrorMessage(null, key, triggerValue);
        triggeredExceededAmountToasts.current = [...triggeredExceededAmountToasts.current, key]
    }

    const showExceedsErrorMessage = (e, key, triggerValue) => {
        if (props.formRecord.isLocked)
            return;

        if(e)
            e.stopPropagation();

        showErrorMessage(`The total amount entered in ${t(`LABELS.${key.toUpperCase()}`)} exceeds the allowed monthly allowance of ${formatValue(triggerValue)}`, key);
    }

    const getGroupedCategories = (data) => {
        let items = data.filter(x => x.items);

        return isMobile ?
            <GroupContainer>
                <Accordion allowMultiple transition transitionTimeout={250}>
                    {items.map((group, i) =>
                    (<AccordionItem initialEntered={false} key={group.key} header={GetGroupTitle(group)} >
                        {GetGroupContent(group, data)}
                    </AccordionItem>))}
                </Accordion>
            </GroupContainer>
            :
            items.map((group) =>
            (<GroupContainer className={group.key} key={group.key}>
                {GetGroupTitle(group)}
                {GetGroupContent(group, data)}
            </GroupContainer>));
    }

    const GetGroupTitle = (group, calcTotals = true) => {
        return <>
            <div className={`group-header ${group.key}`}>
                {group.key === 'household' && <div className="household-icon mr-2"></div>}
                <h6 className="group-name">
                    {labelsToTransform.includes(group.key) && t(`LABELS.${group.key.toUpperCase() + (props.isJoint ? '_JOINT' : '')}`)}
                    {!labelsToTransform.includes(group.key) && t(`LABELS.${group.key.toUpperCase()}`)}
                </h6>
                {calcTotals && getGroupTotalLabel(group.key)}
            </div>
        </>
    }

    const GetGroupContent = (group, categories) => {
        return (<div className="group-content">
            {group.items.sort((a, b) => { return a.sortOrder - b.sortOrder; }).map((item, i) => { return getItemRender(item, i, group.id, categories); })}
        </div>);
    }

    const getItemRender = (item, i, gi, categories) => {
        const getStartingIndex = (groupId, itemIndex, categories) => {
            const offset = 3;
            const groupIndex = categories.map(x => { return x.id }).indexOf(groupId);

            const previousGroupsLength = categories
                .slice(0, groupIndex)
                .reduce((acc, cat) => acc + cat.items.length * 3, 0);

            const currentFieldOffset = itemIndex * 3;

            return offset + previousGroupsLength + currentFieldOffset;
        };

        return <IEFieldContainer
            index={getStartingIndex(gi, i, categories)}
            key={item.type + item.parent}
            parent={item.parent}
            sortOrder={item.sortOrder}
            title={item.type}
            value={item.amount}
            note={item.note}
            isIncomeField={tabItems[selectedTab].dataObject === 'income'}
            frequency={item.frequency}
            isTouched={item.isTouched}
            isLocked={props.formRecord.isLocked}
            isDisabled={item.isDisabled}
            elementType={'number'}
            handleValueChange={handleListChangedValue}
            isInteger={false} />
    }

    const formatValue = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value ? value : 0);
    }

    const getDependantRow = (key, value) => {
        return <h7 className='household-data gap-standard'><span>{t(`LABELS.${key.toUpperCase()}`)}:</span> <strong>{value}</strong></h7>
    }

    const getAdults = () => props.formRecord.formData.householdDetails.adultsInHousehold
    const getUnder16 = () => TriggerFiguresService.getDependantsUnder16(props.formRecord.formData.householdDetails.dependantsInHousehold)
    const getUnder18 = () => TriggerFiguresService.getDependantsUnder18(props.formRecord.formData.householdDetails.dependantsInHousehold)
    const getOther = () => TriggerFiguresService.getOtherDependants(props.formRecord.formData.householdDetails.dependantsInHousehold)

    return (
        <IEBaseContainerElement $tabsLength={tabItems.length}>
            {(selectedTab >= 0 && selectedTab < tabItems.length) &&
                <div className="flex-container">
                    <div className="ie-contaier-header">
                        <header className="ie-contaier-header-text">
                            <h1>{t('PAGE.HEADER')}</h1>
                        </header>

                        <CustomTabs tabItems={tabItems} selectedTab={selectedTab} onTabChange={onTabsSelectionChanged} />

                        {formData.summary && (
                            <div className="summary-items-container">
                                <IESummaryContainer title={t('SUMMARY.TOTAL_INCOME')} value={formData.summary.totalIncome} />
                                <IESummaryContainer title={t('SUMMARY.TOTAL_OUTGOINGS')} $showinfoicon="true" value={formData.summary.totalFixedOutgoings + formData.summary.totalFlexibleOutgoings} />
                                <IESummaryContainer title={t('SUMMARY.CONTRIBUTION')} value={formData.summary.contribution} balance />
                            </div>
                        )}
                    </div>

                    <IECategoryContainerElement className="household-data-container" $hidedesktop="true">
                        <GroupContainer>
                            <Accordion allowMultiple transition transitionTimeout={250}>
                                <AccordionItem initialEntered={false} key="householdGroup" header={GetGroupTitle({ key: 'household' }, false)}>
                                    <div className="group-content household-details pb-0">
                                        <div className='household-data gap-standard'>
                                            <div className="d-flex flex-column">
                                                <span>{t(`LABELS.ADULTSINHOUSEHOLD_LINE_1`)}:</span>
                                                <span>{t(`LABELS.ADULTSINHOUSEHOLD_LINE_2`)}</span>
                                            </div>
                                            <strong>{getAdults()}</strong>
                                        </div>

                                        {getDependantRow('dependantChildrenUnder18', getUnder18())}
                                        {getDependantRow('dependantChildrenUnder16', getUnder16())}
                                        {getDependantRow('otherDependants', getOther())}

                                        <div className='household-data gap-standard justify-content-end mt-3'>
                                            {t('LABELS.NOT_CORRECT')}
                                            <a href="javascript:;" onClick={props.onHouseholdButtonClicked}>{t('BUTTONS.UPDATE')}</a>
                                        </div>
                                    </div>
                                </AccordionItem>
                            </Accordion>
                        </GroupContainer>
                    </IECategoryContainerElement>

                    <IECategoryContainerElement>
                        {primitiveCategories}
                        {groupedCategories}
                    </IECategoryContainerElement>
                </div>
            }
            {(selectedTab > 0 && selectedTab === tabItems.length) && <Spinner inner={true} />}
        </IEBaseContainerElement>
    );
}